import React from "react";

export default function Header() {
  return (
    <div className="header">
      <img alt="" className="logo" src="https://i.imgur.com/zsXaU2U.png" />
    </div>
  );
}
